import {
  InvoiceIncomingEditFormValues,
  InvoiceIncomingItemEditFormValues,
  InvoiceIncomingSearchFormValues,
} from "./types";

export const initialInvoiceIncomingEditForm: InvoiceIncomingEditFormValues = {
  id: null,
  vehicleId: null,
  contactSupplierId: null,
  supplierName: null,
  supplierAddress: null,
  supplierOIB: null,
  supplierVAT: null,
  supplierIBAN: null,
  invoiceNumber: null,
  invoiceDate: new Date(),
  dueDate: null,
  durationDays: null,
  deliveryDate: null,
  totalWithoutTax: null,
  totalTax: null,
  total: null,
  // Ulazni račun je gotovo uvijek u eurima; ekran valutu prikazuje kao oznaku, pa mora imati
  // stvarnu vrijednost, a ne samo pretpostavku.
  currencyId: "EUR",
  exchangeRate: null,
  statusId: null,
  incomingSourceId: null,
  note: null,
  internalNote: null,
  expenseTypeId: null,
  paymentMethodId: null,
  paymentReference: null,
  items: [],
};

export const initialInvoiceIncomingItemEditForm: InvoiceIncomingItemEditFormValues = {
  id: crypto.randomUUID(),
  code: null,
  name: null,
  quantity: 1,
  priceWithoutTax: null,
  priceWithTax: null,
  taxRate: 25,
  discountTypeId: "PERCENTAGE",
  discountAmount: null,
  discountPercent: null,
  total: null,
  note: null,
  kpdCode: null,
  unitOfMeasureId: null,
  expenseTypeId: null,
  billingItemTypeId: null,
};

export const initialInvoiceIncomingSearchForm: InvoiceIncomingSearchFormValues = {
  search: null,
  statusId: null,
  incomingSourceId: null,
  allocationStatus: null,
  invoiceDateFrom: null,
  invoiceDateTo: null,
  dueDateFrom: null,
  dueDateTo: null,
  totalMin: null,
  totalMax: null,
};

/** Kako je račun došao u sustav — vrijednosti stupca `incoming_source_id`. */
export const INCOMING_SOURCE_LABELS: Record<string, string> = {
  provider: "e-Račun",
  manual: "Ručni unos",
  upload: "Učitana datoteka",
};

/**
 * Statusi u kojima raspodjela na vozila ima smisla — trošak nastaje tek iz odobrenog računa
 * (plaćen i djelomično plaćen su prošli odobrenje).
 */
export const INVOICE_INCOMING_ALLOCATABLE_STATUSES = ["approved", "paid", "partially_paid"];

/** Nazivi stanja raspodjele za prikaz i filtar. */
export const INVOICE_ALLOCATION_STATUS_LABELS: Record<string, string> = {
  none: "Nije raspoređeno",
  partial: "Djelomično",
  full: "Raspoređeno",
};

/** Provideri e-računa — vrijednosti stupca `provider_name`. */
export const PROVIDER_LABELS: Record<string, string> = {
  moj_eracun: "Moj eRačun",
  eposlovanje: "ePoslovanje",
};
